import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Stats from "./components/Stats";
import About from "./components/About";
import Projects from "./components/Projects";
import CTABanner from "./components/CTABanner";
import Footer from "./components/Footer";
import QuoteDialog from "./components/QuoteDialog";
import { Toaster } from "./components/ui/toaster";

const Home = () => {
  const [quoteOpen, setQuoteOpen] = useState(false);
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero onQuote={() => setQuoteOpen(true)} />
      <Services />
      <Stats />
      <About onQuote={() => setQuoteOpen(true)} />
      <Projects />
      <CTABanner />
      <Footer />
      <QuoteDialog open={quoteOpen} onOpenChange={setQuoteOpen} />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
